import { render, staticRenderFns } from "./ParticipantTotals.vue?vue&type=template&id=284fd03f&scoped=true"
import script from "./ParticipantTotals.vue?vue&type=script&lang=js"
export * from "./ParticipantTotals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284fd03f",
  null
  
)

export default component.exports